import { API_ENDPOINTS } from '../config/api.js';
import { makeApiRequest } from './apiClient.js';

export const authService = {
  getMenu: async (groupId) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_MENU,
        method: 'POST',
        data: { groupId },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
      console.log('Menu data:', response.data);
    } catch (error) {
      console.error('Get menu error:', error);
      throw error;
    }
  },
  login: async (email, password) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.LOGIN,
        method: 'POST',
        data: { email, password },
      });
      return response.data;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },
  refreshToken: async (refreshToken) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.REFRESH_TOKEN,
        method: 'POST',
        data: { refreshToken },
      });
      return response.data.data;
    } catch (error) {
      console.error('Token refresh error:', error);
      throw error;
    }
  },
  logout: async () => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.LOGOUT,
        method: 'POST',
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Logout error:', error);
      throw error;
    }
  },
  resetPassword: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.RESET_PASSWORD,
        method: "POST",
        data,
      });
      return response.data;
    } catch (error) {
      console.error('Reset password error:', error);
      throw error;
    }
  },
  forgotPassword: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.FORGOT_PASSWORD,
        method: "POST",
        data,
      })
      return response.data;
    } catch (error) {
      console.log('Forgot password error:', error);
      throw error;
    }
  },
changepassword: async (data) => {
  try {
    const response = await makeApiRequest({
      endpoint: API_ENDPOINTS.CHANGE_PASSWORD,
      method: "POST",
      data,
      accessToken: localStorage.getItem('accessToken'),
    });
    return response.data;
  } catch (error) {
    console.log('Change password error:', error);
    throw error; // Just throw, don't try to call setError
  }
},
};
